<div #sidebarContainer (scroll)="updateArrows()" class="main-content custom-font-desktop custom-scrollbar">
    
    <ion-accordion-group class="acc-group" #sbAccordionGP [value]="toggleSideMenuValue">
        <ng-container *ngIf="!this.systemService.minimizedSideBar; else minimizeBar">
            <ng-container *ngFor="let item of sideMenuItems; let i = index">
                <ng-container *ngIf="item.show">
                    <ion-accordion [value]="i" class="acc-tab" *ngIf="item.subItems.length > 0">
                        <ion-item class="acc-item" slot="header" color="page-bg">
                            <ion-label [ngClass]="item.selected ? 'selected-side-item font-17 weight-500 d-flex' : 'font-17 weight-500 d-flex'"
                                ><ion-icon [ngClass]="item.selected ? 'active side-menu-img' : 'side-menu-img'" class="side-menu-img" [src]="item.iconPath" [alt]="item.name"></ion-icon> {{ item.name }}</ion-label
                            >
                        </ion-item>
                        <ng-container *ngFor="let subItem of item.subItems">
                            <div *ngIf="subItem.show" class="ion-padding-horizontal acc-sub-item weight-400" slot="content" (click)="onItemClick(subItem)">
                                <ion-text [ngClass]="subItem.selected ? 'selected-side-item ps-2 font-14' : 'ps-2 font-14'">{{ subItem.name }}</ion-text>
                            </div>
                        </ng-container>
                    </ion-accordion>
                    <div class="acc-item-not-child ion-padding-horizontal" *ngIf="item.subItems.length === 0">
                        <div (click)="onItemClick(item)">
                            <ion-text [ngClass]="item.selected ? 'selected-side-item font-17 weight-500 d-flex' : 'font-17 weight-500 d-flex'"
                                ><ion-icon [ngClass]="item.selected ? 'active side-menu-img' : 'side-menu-img'" class="side-menu-img" [src]="item.iconPath" [alt]="item.name"></ion-icon> {{ item.name }}</ion-text
                            >
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <div class="acc-item-not-child ion-padding-horizontal">
                <div>
                    <ion-text class="font-17 weight-500 d-flex" (click)="onLogOut()"><ion-icon class="side-menu-img" name="log-out-outline"></ion-icon> Logout</ion-text>
                </div>
            </div>
        </ng-container>
        <ng-template #minimizeBar>
            <ng-container *ngFor="let item of sideMenuItems">
                <div class="acc-item-not-child ion-padding-horizontal" *ngIf="item.show">
                    <div (click)="onclickMinimizeSideBar(item)">
                        <!-- <img class="side-menu-img px-0" [src]="item.iconPath" [alt]="item.name" /> -->
                        <ion-icon [ngClass]="item.selected ? 'active side-menu-img' : 'side-menu-img'" class="side-menu-img" [src]="item.iconPath" [alt]="item.name"></ion-icon>
                    </div>
                </div>
            </ng-container>
            <div class="acc-item-not-child ion-padding-horizontal">
                <div (click)="onLogOut()">
                    <ion-icon class="side-menu-img" name="log-out-outline"></ion-icon>
                </div>
            </div>
        </ng-template>
    </ion-accordion-group>

    <div *ngIf="showDownArrow || showUpArrow" (click)="scrollTo(showDownArrow ? 'bottom' : 'top')"  class="down-scroll-container d-flex justify-content-end align-items-center pe-2">
        <img src="assets/icon/back.svg" alt="back" [ngClass]="showDownArrow ? 'down-scroll-icon' : 'up-scroll-icon'" class=" d-none d-lg-inline" />
    </div>
</div>
